import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { init } from 'logrocket';
import { ALERT_TYPE } from '../../providers/myria/app-variables';
import { AuthProvider } from '../../providers/authorization';
import { RouteProvider } from '../../providers/route/route';
import * as $ from 'jquery'


/**
 * Generated class for the RmtAlertsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-alerts',
  templateUrl: 'rmt-alerts.html',
  animations: [
  trigger('visibilityChanged', [
    transition(':leave', [
      style({transform: 'fadeIn', opacity: 1}),
      animate('100ms', style({transform: 'fadeOut', opacity: 0}))
    ])
  ])
]
})
export class RmtAlertsComponent {
  @ViewChild('rmtalert') rmtalert;
  @ViewChild('rmtalerttext') rmtalerttext;
  @Input() includeButton: boolean = false;
  @Input() type : ALERT_TYPE;
  @Input() alertText : string = "";
  @Input() titleText ?: string = "";
  @Input() isInnerHTML?: boolean = false;
  @Input() showClose?: boolean = false;
  @Input() showTitle?: boolean = false;
  @Input() customIcon?: string = "";
  @Input() customAlertStyle ?: string = "";
  @Input() hyperLink ?: string = "";
  @Input() hyperLinkText ?: string='';
  @Input() buttonText ?: string='';
  @Input() additionalStyle ?: string = "";
  @Input() boldAlertText: boolean = false;
  @Input() bootstrapAlert: boolean = false;
  @Input() bootstrapImgAvailable: boolean = false;
  @Input() bootstrapImgPath: string = '';
  @Input() bootstrapIconCenter: boolean = false;
  @Input() bootstrapTextChangeColor: boolean = false;

  @Output() clickButton = new EventEmitter<number>();
  @Output() closePressed = new EventEmitter<number>();
  iconImage: string;
  alertStyle: string;
  isHiddenAlert: boolean = false;
  isHideAlertParent: boolean = false;
  isCenterAlign: boolean = false;
  
  constructor( private auth: AuthProvider, private route: RouteProvider) {
     
  }

  ngAfterViewInit() {
    this.centerAlignSingleLine();

    if (this.boldAlertText){
      $(this.rmtalerttext.nativeElement).addClass("title-text semibold");
    }
  }

  textBasedOnConditions(){
    if (this.titleText && !this.showTitle) {
      return this.titleText + '. ' + this.alertText;
    }

    return this.alertText;
  }

  getAlertStyle() {
    if (this.customAlertStyle)
      return this.customAlertStyle;

    if (!this.alertStyle)
      this.initStyle();

    return this.alertStyle
  }

  getAdditionalStyle() {
    return this.additionalStyle;
  }

  getBootstrapTitleStyle() {
    if (this.bootstrapAlert && this.showTitle && this.titleText && this.type) {
      var style = '';
      switch (this.type) {
        case ALERT_TYPE.ALERT_INFO:
          style = "title-style-info";
          break;
        case ALERT_TYPE.ALERT_WARNING:
          style = "title-style-info-yellow";
          break;
        default:
          style = "title-style-info";
          break;
      }
      return style;
    }
  }

  getBootstrapTextColor() {
    if (this.bootstrapTextChangeColor && this.bootstrapAlert && this.type) {
      var style = '';
      switch (this.type) {
        case ALERT_TYPE.ALERT_WARNING:
          style = "bootstrap-warn-text-color";
          break;
      }
      return style;
    }
  }

  initStyle() {
    if (!this.bootstrapAlert) {
      switch (this.type) {
        case ALERT_TYPE.ALERT_INFO:
          this.iconImage = "assets/icons/alert-info.svg";
          this.alertStyle = "alert-info";
          break;
        case ALERT_TYPE.ALERT_SUCCESS:
          this.iconImage = "assets/icons/alert-success.svg";
          this.alertStyle = "alert-success";
          break;
        case ALERT_TYPE.ALERT_WARNING:
          this.iconImage = "assets/icons/alert-warn.svg";
          this.alertStyle = "alert-warn";
          break;
        case ALERT_TYPE.ALERT_ERROR:
          this.iconImage = "assets/icons/alert-error.svg";
          this.alertStyle = "alert-error";
          break;
        case ALERT_TYPE.ALERT_PENDING:
          this.iconImage = "assets/icons/bold-outline-clock.svg";
          this.alertStyle = "alert-pending";
          break;
      }
    } else if (this.bootstrapAlert) {
      switch (this.type) {
        case ALERT_TYPE.ALERT_INFO:
          this.iconImage = "assets/icons/info-circle-alert.svg";
          this.alertStyle = "alert-info";
          break;
        case ALERT_TYPE.ALERT_WARNING:
          this.iconImage = "assets/icons/warning-alt.svg";
          this.alertStyle = "alert-warn";
          break;
      }
    }
  }

  getIconImage() {
    if(this.customIcon) 
      return this.customIcon;

    if(!this.iconImage)
      this.initStyle();

    return this.iconImage;
  }

  clickDismissed(ev, i) {
    
    const height = $(this.rmtalert.nativeElement.parentNode).outerHeight();
    this.rmtalert.nativeElement.style.height = parseInt(height.toString()) + 'px';
    this.rmtalert.nativeElement.style.transition = '0.2s linear height';
    this.isHiddenAlert = true;
    
    window.setTimeout(() => {
      $(this.rmtalert.nativeElement).addClass('slide-up');
      window.setTimeout(()=> {
        this.closePressed.emit(i);
        this.isHideAlertParent = true;
      }, 200)
    }, 100);
  }

  processButton(ev, i) {
    ev.stopPropagation(); // if there is a click listener on the card itself    
    this.clickButton.emit(i);
  }

  centerAlignSingleLine() {
    const divHeight = $(this.rmtalerttext.nativeElement).height();
    if (this.bootstrapIconCenter)
      this.isCenterAlign = true;
    else if (divHeight > 24 || this.showTitle)
      this.isCenterAlign = false;
    else
      this.isCenterAlign = true;
  }

  async openHyperLink() {
    this.route.openIab(this.hyperLink);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-alerts/rmt-alerts.ts